import service from '../../http/axios';

// 获取权限
export const getRoles = service({
  url: '/yinghe-api/imageDataScienceInitiate/getRoles',
});

// 添加成员
export const createMember = service({
  method: 'POST',
  url: '/yinghe-api/imageDataScienceInitiate/addMember',
});
// 查询成员
export const queryMembers = service({
  url: '/yinghe-api/imageDataScienceInitiate/getRoleByMember',
});
// 删除成员
export const removeMember = service({
  method: 'DELETE',
  url: '/yinghe-api/imageDataScienceInitiate/removeMember',
});
